// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InstanceTrafficPolicyStatus } from './InstanceTrafficPolicyStatus';
import {
  InstanceTrafficPolicyStatusFromJSON,
  InstanceTrafficPolicyStatusFromJSONTyped,
  InstanceTrafficPolicyStatusToJSON,
  InstanceTrafficPolicyStatusToJSONTyped,
} from './InstanceTrafficPolicyStatus';

/**
 * Full traffic policy state for one instance, including last-applied detail. Used in the internal support overview only.
 *
 * @export
 * @interface InstanceTrafficPolicyDetail
 */
export interface InstanceTrafficPolicyDetail {
  /**
   *
   * @type {string}
   * @memberof InstanceTrafficPolicyDetail
   */
  instanceId?: string;
  /**
   *
   * @type {InstanceTrafficPolicyStatus}
   * @memberof InstanceTrafficPolicyDetail
   */
  state?: InstanceTrafficPolicyStatus;
  /**
   * The endpoint IDs currently in the desired spec.
   * @type {Array<string>}
   * @memberof InstanceTrafficPolicyDetail
   */
  desired?: Array<string>;
  /**
   * When the operator last ran for this instance, regardless of outcome.
   * @type {Date}
   * @memberof InstanceTrafficPolicyDetail
   */
  lastReportedAt?: Date;
  /**
   * The endpoint IDs that were applied on the last operator reconciliation.
   * @type {Array<string>}
   * @memberof InstanceTrafficPolicyDetail
   */
  applied?: Array<string>;
}

/**
 * Check if a given object implements the InstanceTrafficPolicyDetail interface.
 */
export function instanceOfInstanceTrafficPolicyDetail(
  value: object,
): value is InstanceTrafficPolicyDetail {
  return true;
}

export function InstanceTrafficPolicyDetailFromJSON(
  json: any,
): InstanceTrafficPolicyDetail {
  return InstanceTrafficPolicyDetailFromJSONTyped(json, false);
}

export function InstanceTrafficPolicyDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InstanceTrafficPolicyDetail {
  if (json == null) {
    return json;
  }
  return {
    instanceId: json['instance_id'] == null ? undefined : json['instance_id'],
    state:
      json['state'] == null
        ? undefined
        : InstanceTrafficPolicyStatusFromJSON(json['state']),
    desired: json['desired'] == null ? undefined : json['desired'],
    lastReportedAt:
      json['last_reported_at'] == null
        ? undefined
        : new Date(json['last_reported_at']),
    applied: json['applied'] == null ? undefined : json['applied'],
  };
}

export function InstanceTrafficPolicyDetailToJSON(
  json: any,
): InstanceTrafficPolicyDetail {
  return InstanceTrafficPolicyDetailToJSONTyped(json, false);
}

export function InstanceTrafficPolicyDetailToJSONTyped(
  value?: InstanceTrafficPolicyDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    instance_id: value['instanceId'],
    state: InstanceTrafficPolicyStatusToJSON(value['state']),
    desired: value['desired'],
    last_reported_at:
      value['lastReportedAt'] == null
        ? undefined
        : value['lastReportedAt'].toISOString(),
    applied: value['applied'],
  };
}
